import { useState } from "react";

export function useSelectionSet(keys, maxSelected = Infinity) {
  const [selected, setSelected] = useState(new Set());

  const visibleSelected = keys.filter((key) => selected.has(key));
  const allSelected = keys.length > 0 && visibleSelected.length === keys.length;
  const someSelected = visibleSelected.length > 0 && !allSelected;
  const limitReached =
    keys.length > maxSelected && visibleSelected.length >= maxSelected;

  const toggleAll = () => {
    setSelected(
      visibleSelected.length > 0
        ? new Set()
        : new Set(keys.slice(0, maxSelected)),
    );
  };

  const toggleOne = (key) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else if (next.size < maxSelected) {
        next.add(key);
      }
      return next;
    });
  };

  return {
    selected,
    setSelected,
    visibleSelected,
    allSelected,
    someSelected,
    limitReached,
    toggleAll,
    toggleOne,
  };
}
